import valid from "card-validator";
import { object, string } from "yup";
import { Constants } from "config/constants";

export const validationSchema = object().shape({
  firstName: string().required("First name is required"),
  lastName: string().required("Last name is required"),
  email: string()
    .email("Invalid email address format")
    .required("Email is required"),
  mobileNumber: string().required("Phone number is required"),
  billingAddress: string().required("Billing address is required"),
});
